import { useTranslation } from 'react-i18next';

import betterflyLogo from '../../../../../../assets/icons/betterfly-small-logo.png';
import { ReactComponent as SidebarToggleIcon } from '../../../../../../assets/icons/icon-sidebar-toggle.svg';
import { ISidebarHeaderProps } from '../../../../../interfaces/globals';
import { TRANSLATIONS_GLOBAL } from '../../../../../translations/commons';
import Tooltip from '../../../Tooltip/Tooltip';

const SidebarHeader = ({ collapsed, onToggle }: ISidebarHeaderProps) => {
  const { t } = useTranslation();

  if (collapsed) {
    return (
      <div className="sidebar__header">
        <Tooltip content={t(TRANSLATIONS_GLOBAL.sidebar.headerTooltip)} placement="right">
          <button
            className="sidebar__toggle sidebar__toggle--expand"
            onClick={onToggle}
            aria-label={t(TRANSLATIONS_GLOBAL.sidebar.headerTooltip)}
          >
            <span className="sidebar__toggle-logo-wrap" aria-hidden="true">
              <img src={betterflyLogo} alt="" width="32" height="32" />
            </span>
            <span className="sidebar__toggle-icon-wrap" aria-hidden="true">
              <SidebarToggleIcon />
            </span>
          </button>
        </Tooltip>
      </div>
    );
  }

  return (
    <div className="sidebar__header">
      <div className="sidebar__logo">
        <img src={betterflyLogo} alt="Betterfly" width="32" height="32" />
      </div>
      <span className="sidebar__product-name">{t(TRANSLATIONS_GLOBAL.sidebar.title)}</span>
      <button
        className="sidebar__toggle"
        onClick={onToggle}
        title={t(TRANSLATIONS_GLOBAL.sidebar.title)}
        aria-label={t(TRANSLATIONS_GLOBAL.sidebar.title)}
      >
        <SidebarToggleIcon aria-hidden="true" />
      </button>
    </div>
  );
};

export default SidebarHeader;
